/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SiteNavDropdownImageModule_navigationModule$ref = any;
export type SiteNavDropdownImageModule_navigationModule = {
    readonly imageUrl: string | null;
    readonly imageLink: string | null;
    readonly imageTitlePrimary: string | null;
    readonly imageTitleSecondary: string | null;
    readonly imageHeight: string | null;
    readonly imageWidth: string | null;
    readonly " $refType": SiteNavDropdownImageModule_navigationModule$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SiteNavDropdownImageModule_navigationModule",
  "type": "NavigationModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageLink",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageTitlePrimary",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageTitleSecondary",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageHeight",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageWidth",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'db59f28d0d3be1977e14230156039641';
export default node;
